"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE_SUPPORT_NUMBER = exports.PHONE_SUPPORT_END_TIME_FORMAT = exports.PHONE_SUPPORT_START_TIME_FORMAT = exports.PHONE_SUPPORT_END_TIME = exports.PHONE_SUPPORT_START_TIME = exports.LABEL_EMAIL_NAME_ACCOUNT = exports.LABEL_STUDIO = exports.LABEL_SPONSORSHIPS = exports.LABEL_INTERESTS = exports.LABEL_COLLECTIONS = exports.LABEL_FOLLOWING = exports.LABEL_TICKETS = exports.LABEL_SAVED = exports.LABEL_ORGANIZER_PROFILE = exports.LABEL_MY_EVENTS = exports.LABEL_MY_CONTACTS = exports.LABEL_ACCOUNT = exports.LABEL_HELP_CENTER = exports.CATEGORY_HEADER = exports.ACTION_PHONE_SUPPORT_CLICK = exports.ACTION_LOGOUT = exports.ACTION_PROFILE_DROPDOWN = exports.ACTION_LOGO_HOME = exports.ACTION_LOGIN_ATTEMPT = exports.ACTION_HELP_ARTICLE = exports.ACTION_DISCOVER = exports.ACTION_CREATE_ATTEMPT = exports.FALLBACK_SUGGESTIONS = exports.FALLBACK_CATEGORIES = exports.SUGGESTIONS_RESPONSE_GROUPS = exports.DEFAULT_LOCATION = exports.SUGGESTIONS_API_URL = exports.DEFAULT_USER_LOCATION = exports.USER_LOCATION_COOKIE = exports.DESTINATION_SUGGESTIONS_RESPONSE_GROUPS = exports.DESTINATION_SUGGESTIONS_API_URL = exports.USER_SHAPE_PROP_TYPE = exports.REQUEST_SHAPE_PROP_TYPE = exports.ENV_SHAPE_PROP_TYPE = void 0;

var _gettext = _interopRequireDefault(require("js-utils/gettext"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _siteFooter = require("@eb/site-footer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEADER_ORGANIZE_LINKS_PROP_TYPE = _propTypes.default.shape({
  home: _propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    gaLabel: _propTypes.default.string
  }).isRequired,
  suggested: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    gaLabel: _propTypes.default.string
  })).isRequired
});

var ENV_SHAPE_PROP_TYPE = _propTypes.default.shape({
  serverUrl: _propTypes.default.string.isRequired,
  ebDomain: _propTypes.default.string.isRequired,
  adminServerUrl: _propTypes.default.string.isRequired,
  signupUrl: _propTypes.default.string.isRequired,
  loginUrl: _propTypes.default.string.isRequired,
  logoutUrl: _propTypes.default.string.isRequired,
  searchLocation: _propTypes.default.shape({
    address: _propTypes.default.string
  }).isRequired,
  locales: _siteFooter.LOCALES_ARRAY_PROP_TYPE.isRequired,
  localeInfo: _siteFooter.LOCALE_INFO_SHAPE_PROP_TYPE.isRequired,
  helpUrls: _siteFooter.HELP_LINKS_PROP_TYPE.isRequired,
  organizeUrls: HEADER_ORGANIZE_LINKS_PROP_TYPE.isRequired,
  searchQuery: _propTypes.default.string,
  isNewAccountSettingsActive: _propTypes.default.bool
});

exports.ENV_SHAPE_PROP_TYPE = ENV_SHAPE_PROP_TYPE;

var REQUEST_SHAPE_PROP_TYPE = _propTypes.default.shape({
  path: _propTypes.default.string.isRequired
});

exports.REQUEST_SHAPE_PROP_TYPE = REQUEST_SHAPE_PROP_TYPE;

var USER_SHAPE_PROP_TYPE = _propTypes.default.shape({
  canInvite: _propTypes.default.bool,
  canCreateEvents: _propTypes.default.bool,
  firstName: _propTypes.default.string,
  fullName: _propTypes.default.string,
  hasEvents: _propTypes.default.bool,
  hasOrganizers: _propTypes.default.bool,
  hasTikibar: _propTypes.default.bool,
  isAttendee: _propTypes.default.bool,
  isAuthenticated: _propTypes.default.bool,
  isStaff: _propTypes.default.bool,
  numOrders: _propTypes.default.number,
  numSavedEvents: _propTypes.default.number,
  publicId: _propTypes.default.string,
  thumbnailUrl: _propTypes.default.string,
  numFollowing: _propTypes.default.number
});

exports.USER_SHAPE_PROP_TYPE = USER_SHAPE_PROP_TYPE;
var DESTINATION_SUGGESTIONS_API_URL = '/api/v3/destination/search/autocomplete/';
exports.DESTINATION_SUGGESTIONS_API_URL = DESTINATION_SUGGESTIONS_API_URL;
var DESTINATION_SUGGESTIONS_RESPONSE_GROUPS = ['event'];
exports.DESTINATION_SUGGESTIONS_RESPONSE_GROUPS = DESTINATION_SUGGESTIONS_RESPONSE_GROUPS;
var USER_LOCATION_COOKIE = 'location';
exports.USER_LOCATION_COOKIE = USER_LOCATION_COOKIE;
var UNITED_STATES_PLACE_ID = 85633793;
var DEFAULT_USER_LOCATION = UNITED_STATES_PLACE_ID;
exports.DEFAULT_USER_LOCATION = DEFAULT_USER_LOCATION;
var SUGGESTIONS_API_URL = '/directory/autocomplete/';
exports.SUGGESTIONS_API_URL = SUGGESTIONS_API_URL;
var DEFAULT_LOCATION = 'Current Location';
exports.DEFAULT_LOCATION = DEFAULT_LOCATION;
var SUGGESTIONS_RESPONSE_GROUPS = ['top_match', 'events', 'organizers', 'categories', 'popular_queries'];
exports.SUGGESTIONS_RESPONSE_GROUPS = SUGGESTIONS_RESPONSE_GROUPS;
var FALLBACK_CATEGORIES = [{
  type: 'Category',
  category: (0, _gettext.default)('Categories'),
  label: (0, _gettext.default)('Arts'),
  source: 'autocomp',
  url: '/d/local/arts--events/',
  value: 'Arts'
}, {
  type: 'Category',
  category: (0, _gettext.default)('Categories'),
  label: (0, _gettext.default)('Business'),
  source: 'autocomp',
  url: '/d/local/business--events/',
  value: 'Business'
}, {
  type: 'Category',
  category: (0, _gettext.default)('Categories'),
  label: (0, _gettext.default)('Charity & Causes'),
  source: 'autocomp',
  url: '/d/local/charity-and-causes--events/',
  value: 'Charity & Causes'
}, {
  type: 'Category',
  category: (0, _gettext.default)('Categories'),
  label: (0, _gettext.default)('Community'),
  source: 'autocomp',
  url: '/d/local/community--events/',
  value: 'Community'
}, {
  type: 'Category',
  category: (0, _gettext.default)('Categories'),
  label: (0, _gettext.default)('Film & Media'),
  source: 'autocomp',
  url: '/d/local/film-and-media--events/',
  value: 'Film & Media'
}, {
  type: 'Category',
  category: (0, _gettext.default)('Categories'),
  label: (0, _gettext.default)('Food & Drink'),
  source: 'autocomp',
  url: '/d/local/food-and-drink--events/',
  value: 'Food & Drink'
}, {
  type: 'Category',
  category: (0, _gettext.default)('Categories'),
  label: (0, _gettext.default)('Music'),
  source: 'autocomp',
  url: '/d/local/music--events/',
  value: 'Music'
}, {
  type: 'Category',
  category: (0, _gettext.default)('Categories'),
  label: (0, _gettext.default)('All Categories'),
  source: 'autocomp',
  url: '/d/local/all-events/',
  value: 'All Categories'
}];
exports.FALLBACK_CATEGORIES = FALLBACK_CATEGORIES;
var FALLBACK_SUGGESTIONS = FALLBACK_CATEGORIES.map(function (_ref) {
  var label = _ref.label,
      url = _ref.url;
  return {
    content: label,
    value: url
  };
});
exports.FALLBACK_SUGGESTIONS = FALLBACK_SUGGESTIONS;
var ACTION_CREATE_ATTEMPT = 'CreateAttempt';
exports.ACTION_CREATE_ATTEMPT = ACTION_CREATE_ATTEMPT;
var ACTION_DISCOVER = 'Discover';
exports.ACTION_DISCOVER = ACTION_DISCOVER;
var ACTION_HELP_ARTICLE = 'HelpArticle';
exports.ACTION_HELP_ARTICLE = ACTION_HELP_ARTICLE;
var ACTION_LOGIN_ATTEMPT = 'LoginAttempt';
exports.ACTION_LOGIN_ATTEMPT = ACTION_LOGIN_ATTEMPT;
var ACTION_LOGO_HOME = 'LogoHome';
exports.ACTION_LOGO_HOME = ACTION_LOGO_HOME;
var ACTION_PROFILE_DROPDOWN = 'ProfileDropdown';
exports.ACTION_PROFILE_DROPDOWN = ACTION_PROFILE_DROPDOWN;
var ACTION_LOGOUT = 'Logout';
exports.ACTION_LOGOUT = ACTION_LOGOUT;
var ACTION_PHONE_SUPPORT_CLICK = 'ClickOnPhoneSupportLink';
exports.ACTION_PHONE_SUPPORT_CLICK = ACTION_PHONE_SUPPORT_CLICK;
var CATEGORY_HEADER = 'header';
exports.CATEGORY_HEADER = CATEGORY_HEADER;
var LABEL_HELP_CENTER = 'HelpCenter';
exports.LABEL_HELP_CENTER = LABEL_HELP_CENTER;
var LABEL_ACCOUNT = 'Account';
exports.LABEL_ACCOUNT = LABEL_ACCOUNT;
var LABEL_MY_CONTACTS = 'My Contacts';
exports.LABEL_MY_CONTACTS = LABEL_MY_CONTACTS;
var LABEL_MY_EVENTS = 'My Events';
exports.LABEL_MY_EVENTS = LABEL_MY_EVENTS;
var LABEL_ORGANIZER_PROFILE = 'My Organizer Profile';
exports.LABEL_ORGANIZER_PROFILE = LABEL_ORGANIZER_PROFILE;
var LABEL_SAVED = 'Saved';
exports.LABEL_SAVED = LABEL_SAVED;
var LABEL_TICKETS = 'Tickets';
exports.LABEL_TICKETS = LABEL_TICKETS;
var LABEL_FOLLOWING = 'Following';
exports.LABEL_FOLLOWING = LABEL_FOLLOWING;
var LABEL_COLLECTIONS = 'Collections';
exports.LABEL_COLLECTIONS = LABEL_COLLECTIONS;
var LABEL_INTERESTS = 'Interests';
exports.LABEL_INTERESTS = LABEL_INTERESTS;
var LABEL_SPONSORSHIPS = 'Sponsorships';
exports.LABEL_SPONSORSHIPS = LABEL_SPONSORSHIPS;
var LABEL_STUDIO = 'Studio';
exports.LABEL_STUDIO = LABEL_STUDIO;
var LABEL_EMAIL_NAME_ACCOUNT = 'EmailAndNameAccount';
exports.LABEL_EMAIL_NAME_ACCOUNT = LABEL_EMAIL_NAME_ACCOUNT;
var PHONE_SUPPORT_START_TIME = '08:00';
exports.PHONE_SUPPORT_START_TIME = PHONE_SUPPORT_START_TIME;
var PHONE_SUPPORT_END_TIME = '18:30';
exports.PHONE_SUPPORT_END_TIME = PHONE_SUPPORT_END_TIME;
var PHONE_SUPPORT_START_TIME_FORMAT = 'hA';
exports.PHONE_SUPPORT_START_TIME_FORMAT = PHONE_SUPPORT_START_TIME_FORMAT;
var PHONE_SUPPORT_END_TIME_FORMAT = 'h:mmA';
exports.PHONE_SUPPORT_END_TIME_FORMAT = PHONE_SUPPORT_END_TIME_FORMAT;
var PHONE_SUPPORT_NUMBER = '1-877-267-6805';
exports.PHONE_SUPPORT_NUMBER = PHONE_SUPPORT_NUMBER;
//# sourceMappingURL=constants.js.map